import { apiGatewayService } from './../apiService/HttpService';
import { setEndPoint } from './../apiService/SetEndPoint';
import { reportsEndPoints } from './../apiService/ReportsEndPoints';

class CouponReportService {
  static getCustomerListData(...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getCustomerList, ...extraParams),
    });
  }

  static getSalesOfficerListData(...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getSalesOfficerList, ...extraParams),
    });
  }

  static getCorporateReportData(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getCorporateReport, ...extraParams),
      params,
    });
  }

  static getCustomerCorporateReportData(params, ...extraParams) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(reportsEndPoints.getCustomerCorporateReport, ...extraParams),
      params,
    });
  }
}
export default CouponReportService;
